import { useMutation } from '@apollo/client';

import { SAFELIST_TWILIO_USER } from '../data/mutations/safelistTwilioUser.gql';
import { GET_USER_TWILIO_STATE } from '../data/queries/getUserTwilioState.gql';

export interface SafelistTwilioUserResult {
  __typename: string;
  successMessage?: string;
  failureMessage?: string;
  message?: string;
  responseType?: string;
  invalidFields?: Array<{
    fieldName: string;
    reason: string;
    __typename: string;
  }>;
}

export interface UseSafelistTwilioUserResult {
  safelistUser: (userId: string) => Promise<SafelistTwilioUserResult | null>;
  loading: boolean;
  error: Error | null;
}

export const useSafelistTwilioUser = (): UseSafelistTwilioUserResult => {
  const [safelistMutation, { loading, error }] = useMutation(
    SAFELIST_TWILIO_USER,
    {
      errorPolicy: 'all',
    }
  );

  const safelistUser = async (
    userId: string
  ): Promise<SafelistTwilioUserResult | null> => {
    const result = await safelistMutation({
      variables: { id: userId },
      update: (cache, { data }) => {
        const response = data?.safelistTwilioUser;
        if (response?.__typename === 'SafelistTwilioUserSuccess') {
          // Update the cache to reflect the successful safelist operation
          cache.writeQuery({
            query: GET_USER_TWILIO_STATE,
            variables: { id: userId },
            data: {
              userTwilioState: {
                __typename: 'UserTwilioState',
                status: 'OK',
              },
            },
          });
        }
      },
    });

    return result.data?.safelistTwilioUser || null;
  };

  return {
    safelistUser,
    loading,
    error: error || null,
  };
};
